import React from "react";
import moment from "moment/moment";
import { useLocaleContext } from "../../../context/LocaleContext";
import { usePlayerContext } from "../../../context/PlayerContext";
import Stopped from "./Stopped";
import Starting from "./Starting";
import Waiting from "./Waiting";
import Paused from "./Paused";
import MiniPlayer from "./MiniPlayer";
import Interrupted from "./Interrupted";
import { STREAM_STATUSES } from "../../../constants/common";

import "./style.scss";

export const overlays = {
    [STREAM_STATUSES.STOPPED]: ({ event }) => (
        <Overlay event={event} testSystem={false}>
            <Stopped event={event} />
        </Overlay>
    ),
    [STREAM_STATUSES.INTERRUPTED]: ({ event, stream }) => (
        <Interrupted event={event} stream={stream} />
    ),
    [STREAM_STATUSES.PAUSED]: ({ event, stream }) => <Paused event={event} stream={stream} />,
    [STREAM_STATUSES.FLOATING]: (event) => (
        <Overlay event={event} testSystem={false}>
            <MiniPlayer />
        </Overlay>
    ),
    [STREAM_STATUSES.WAITING]: ({ event, stream, embedEpisode, onHidePlayer }) => (
        <Overlay event={event} status={STREAM_STATUSES.WAITING} testSystem={event?.moduleBranding?.testSystemLink}>
            <Waiting timeStart={moment.unix(embedEpisode?.timeStart || stream?.timeStart)} onHidePlayer={onHidePlayer} />
        </Overlay>
    ),
    [STREAM_STATUSES.STARTING]: ({ event }) => (
        <Overlay event={event} testSystem={event?.moduleBranding?.testSystemLink}>
            <Starting />
        </Overlay>
    ),
}

const Overlay = ({ event, testSystem = true, status, children }) => {
    const { get } = useLocaleContext();
    const { showCountdown } = usePlayerContext();
    const className = 'stream-player-overlay';

    const willRenderCountdown = (showCountdown !== null && showCountdown !== undefined) ? showCountdown : event?.moduleBranding?.showCountdown;
    const disableLayer = status === STREAM_STATUSES.WAITING && !willRenderCountdown;

    if (disableLayer) return null;

    return (
        <section className="player-block-overlay" >
            <section className={`${className}`}>
                <div className="stream-player-overlay-body">
                    {children}
                </div>
                {testSystem && <footer>
                    <a className="button" href="https://comdi.com/test_system" target="_blank">
                        {get('broadcast.overlay.testSystemButton')}
                    </a>
                </footer>}
            </section>
        </section>
    );
};
